<ng-template #logo let-$logo="$logo">
  <img class="profile-logo" src="/assets/logos/{{$logo}}" alt="logo">
  {{$logo | titlecase}}
</ng-template>

<div class="dropdown">
  <button class="btn btn-light dropdown-toggle form-control" type="button" id="profileLogo"
    data-bs-toggle="dropdown" aria-expanded="false">
    @if (selectedIcon()) {
      <ng-container [ngTemplateOutlet]="logo"
        [ngTemplateOutletContext]="{$logo: selectedIcon()}"
       />
    } @else {
      None
    }
  </button>
  <ul class="dropdown-menu" aria-labelledby="profileLogo">
    @for ($logo of icons(); track $logo) {
      <li>
        <button class="dropdown-item" (click)="selectedIcon.set($logo)">
          <ng-container [ngTemplateOutlet]="logo" [ngTemplateOutletContext]="{$logo}" />
        </button>
      </li>
    }
  </ul>
</div>
